import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { EMPLOYEE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateDeleteEmployee = async ({ id, acknowledgeImpact }: { id: string, acknowledgeImpact?: boolean }) => {
  return await axiosAuth.delete(`${EMPLOYEE_API}/${id}${acknowledgeImpact ? '?acknowledgeImpact=true' : ''}`);
};

const useDeleteEmployeeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      acknowledgeImpact?: boolean;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteEmployee,
    ...queryParams,
  });

export default useDeleteEmployeeMutation;
